import React from "react";
import { Link } from "react-router-dom";

export default function Footer_menu_other(props) {
  return (
    <div className="footer-menu-wrapper">
      <h6 className="footer-title">{props.title}</h6>

      <ul className="footer-menu-list">
        <li><Link to="/aboutus">{props.text1}</Link></li>
        <li><Link to="/contactus">{props.text2}</Link></li>
        <li><Link to="/Termandcondition">{props.text3}</Link></li>
        <li><Link to="/Privacy">{props.text4}</Link></li>
      </ul>
    </div>
  );
}